import { Component } from '@theme/component';
/** Mobile navigation delegates to the existing header search, cart and wishlist. */
class ZoobiBottomBar extends Component {
  #controller;
  #observer;
  #resize;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('click', event => {
      const link = event.target.closest('a[data-action]');
      if (!link || link.hasAttribute('data-custom-link')) return;
      const action = link.dataset.action;
      if (action === 'search') {
        const input = document.querySelector('.zhd__search input');
        if (input && input.getClientRects().length) { event.preventDefault(); input.scrollIntoView({ block: 'center', behavior: 'instant' }); input.focus(); }
      }
      if (action === 'cart') {
        const trigger = document.querySelector('.zhd [data-testid="cart-drawer-trigger"]');
        if (trigger) { event.preventDefault(); trigger.click(); }
      }
      if (action === 'saved') {
        const trigger = document.querySelector('zoobi-saved [data-open-saved]');
        if (trigger) { event.preventDefault(); trigger.click(); const dialog = trigger.closest('zoobi-saved').querySelector('dialog'); dialog?.addEventListener('close', () => link.focus(), { once: true, signal }); }
      }
    }, { signal });
    const sync = () => {
      const cart = document.querySelector('.zhd .cart-bubble__text-count')?.textContent.trim();
      const saved = document.querySelector('zoobi-saved [data-saved-count]')?.textContent.trim();
      for (const el of this.querySelectorAll('[data-bottom-cart-count]')) if (cart !== undefined && el.textContent !== cart) el.textContent = cart;
      for (const el of this.querySelectorAll('[data-bottom-saved-count]')) if (saved !== undefined && el.textContent !== saved) el.textContent = saved;
    };
    this.#observer?.disconnect();
    this.#observer = new MutationObserver(sync);
    const header = document.querySelector('zoobi-header');
    if (header) this.#observer.observe(header, { childList: true, characterData: true, subtree: true });
    window.addEventListener('pageshow', sync, { signal });
    window.addEventListener('storage', sync, { signal });
    this.#resize?.disconnect();
    this.#resize = new ResizeObserver(() => document.body.style.setProperty('--zmb-space', `${this.getBoundingClientRect().height}px`));
    this.#resize.observe(this);
    sync();
  }
  disconnectedCallback() {
    this.#controller?.abort(); this.#observer?.disconnect(); this.#resize?.disconnect();
    document.body.style.removeProperty('--zmb-space');
    super.disconnectedCallback();
  }
}
if (!customElements.get('zoobi-bottom-bar')) customElements.define('zoobi-bottom-bar', ZoobiBottomBar);
